import { TemplateName } from "../types";
import { NewlyNotReportingListTemplate } from "./listTemplate";
export class NewlyNotReportingGeneralTemplate extends NewlyNotReportingListTemplate {
    constructor() {
        super(...arguments);
        this.id = TemplateName.NewlyNotReportingGeneral;
    }
}
//# sourceMappingURL=general.js.map